import { render, staticRenderFns } from "./ViewVariantsCore.vue?vue&type=template&id=d2cbb4b8&scoped=true"
import script from "./ViewVariantsCore.vue?vue&type=script&lang=js"
export * from "./ViewVariantsCore.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=d2cbb4b8&prod&scoped=true&lang=css&external"
import style1 from "./ViewVariantsCore.vue?vue&type=style&index=1&id=d2cbb4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cbb4b8",
  null
  
)

export default component.exports